import React, { useRef } from 'react';
import DataGrid,{ Column, Export, Button as ButtonGrid } from 'devextreme-react/data-grid';
import Nuevo from './Nuevo';
import { store } from '../../services/store';
import uri from '../../utils/uri';
import BlockHeader from '../shared/BlockHeader';
import Title from '../shared/Title';
import CustomButton from '../../components/buttons/CustomButton';
import { useDispatch } from 'react-redux';
import { updateGraduacion } from '../../store/graduacion/graduacionReducer';
import urlReport from '../../services/reportServices';
const Graduaciones = props => {

    const { id } = props;

    const dispatch = useDispatch();

    let dataGrid = useRef();

    const onToolbarPreparing = (e) => {  
        e.toolbarOptions.items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                text: 'Exportar a excel',
                icon:'xlsxfile',
                type:'success',
                stylingMode:"outlined",
                onClick: () =>  dataGrid.current.instance.exportToExcel(false)
            }
        },{
            location: 'before',
            widget: 'dxButton',
            options: {
                text: 'Imprimir Graduaciones',
                icon:'exportpdf',
                type:'danger',
                stylingMode:"outlined",
                onClick: () => {                   

                    const report = urlReport();
                    report.print(report.records(null, null, id));

                }
            }
        });
    }  

    const reload = () => dataGrid.current.instance.refresh()

    const onRowDblClick = (e) => {
        openDialog(e.data.id);
    }

    const openDialog = _id => {
        dispatch(updateGraduacion({ open: true,clientId : id, id : _id}))
    }

    const printCard = id => {

        const report = urlReport();
        report.print(`${report.card(id)}`);
        
    }

    const addMenuItems =(e) => {

        if (e.target == "content") {
            
            if (!e.items) e.items = [];
            
            if(e.rowIndex >= 0){

                e.items.push({
                    
                    text: 'Imprimir',
                    icon : 'doc',
                    onItemClick: () => printCard(e.row.data.id)                    
                    
                });
            }
        }

    }

    const title = "Graduaciones"

    return (
        <div>
            <Title title={title} />
            <BlockHeader title={title} >
                <CustomButton
                    type="default"
                    text="Agregar graduacion"
                    icon='plus'                   
                    onClick={()=>  openDialog(0)}
                />
            </BlockHeader>
            <Nuevo reload={reload}/>
            <DataGrid
                ref={dataGrid}
                dataSource={store({ uri: uri.records(id) })}
                selection={{ mode: 'single' }}
                showBorders={true}
                showRowLines={true}
                allowColumnResizing={true}
                allowColumnReordering={true}
                hoverStateEnabled={true}
                rowAlternationEnabled={true}
                onToolbarPreparing={onToolbarPreparing}
                onRowDblClick={onRowDblClick}
                onContextMenuPreparing={addMenuItems}
            >                
                <Export enabled={false} fileName={title} allowExportSelectedData={true} />
                <Column type="buttons">
                    <ButtonGrid name="modificar" text="Ver" onClick={e => openDialog(e.row.data.id)}/>
                </Column>
                <Column dataField="date" caption="Fecha" width={110} dataType="date" format="dd/MM/yyyy" />
                <Column dataField="resumenOd" allowFiltering={false} />
                <Column dataField="resumenOi" allowFiltering={false} />               
                <Column dataField="dp" caption="DPL/DPC" width={80} allowFiltering={false} />               
                <Column dataField="nextDateRecord" allowFiltering={false} caption="Próx grad" width={120} dataType="date" format="dd/MM/yyyy"/>              
            
                <Column type="buttons" width={70}>
                    <ButtonGrid name="print" icon="doc" hint="Imprimir" onClick={e => printCard(e.row.data.id)}/>
                </Column>             
            </DataGrid>
        </div>
    );
}

export default Graduaciones;
